module.exports = __webpack_public_path__ + "img/public.dacb5bb1.svg";